import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import MIcon from '../m-icon/MIcon';
import { createPortal } from 'react-dom';

function MModal({
                    active, setActive, children, onCloseModal = () => {
    }, withCloseButton = true
                }) {
    const dispatch = useDispatch();

    const onClose = () => {
        onCloseModal();
        setActive(false);
    };

    const modalRoot = document.getElementById('modal-root');

    // z-[100] — выше плавающих кнопок (z-index: 30) и открытого меню навбара (z-[70]),
    // иначе они накладываются поверх модального окна
    return active ? createPortal(
      <div
        className={`${!active && 'hidden'} w-[100vw] h-[100vh] bg-[rgba(0,0,0,0.5)] p-2 tablet:p-8  fixed top-0 left-0 flex justify-center items-center overflow-auto z-[100]`}
      >

          <div
            className='p-4 m-6 tablet:p-8 rounded-xl bg-white relative max-w-full max-h-full overflow-auto'
            onClick={e => e.stopPropagation()}
          >
              {withCloseButton && (
                <button
                  className='absolute top-3 right-3 hover:cursor-pointer text-main-color'
                  onClick={onClose}
                >
                    <MIcon
                      type={'close'}
                      className='text-main-color'
                    />
                </button>
              )}
              {children}
          </div>
      </div>, modalRoot
    ) : null;
}

export default memo(MModal);
